export const GET_COMBOS_REQUEST = 'GET_COMBOS_REQUEST';
export const GET_COMBOS_RESPONSE = 'GET_COMBOS_RESPONSE';
